import {formattPrice} from './utils'

const calcBoxPrice = {
  prodBox: document.querySelectorAll(".jsProdBox") as NodeListOf<HTMLElement>,
  init() {
    this.calcPrice();
  },
  calcPrice() {
    this.prodBox.forEach((item) => {
      const priceHtml = item.querySelector(".jsProdBoxPrice") as HTMLElement;
      const items = item.querySelectorAll(
        ".jsKittingWrap"
      ) as NodeListOf<HTMLElement>;
      if (items.length) {
        const required = [...items].filter((item) => {
          const min = item.dataset.min as string;

          return +min > 0;
        });

        let price = 0;  
        required.forEach((el) => {
          const items = el.querySelectorAll(
            ".jsKittingPrice"
          ) as NodeListOf<HTMLElement>;
          const sorted = [...items].sort((a, b) => {
            const price1 = a.dataset.price as string;
            const price2 = b.dataset.price as string;
            return +price1 - +price2;
          });
          const itemPrice = sorted[0].dataset.price as string;
          price += +itemPrice;
        });

        priceHtml.innerHTML = `<span>${formattPrice(+price.toFixed(2))}</span>`;
      }
    });
  },
};

export default calcBoxPrice;
